import React from "react";
import { Navigate } from "react-router-dom";
import { PathNames } from "./constants";

import HomePage from "common/home";
import LoginPage from "common/auth/signIn";
import ErrorPage from "../pages/error/ErrorPage";

export const authRouts = [
  {
    path: PathNames.login,
    title: "Login",
    component: <LoginPage />,
  },
  {
    path: "/*",
    title: "Login Redirection",
    component: <Navigate to={PathNames.login} />,
  },
];

export const publicRouts = [
  {
    path: PathNames.home,
    title: "Home",
    component: <HomePage />,
  },
  {
    path: "/*",
    title: "Error",
    component: <ErrorPage />,
  },
];
